module.exports = "/assets/data/04427662355afbdf8d1be37f8633bf31-LN2.data.json";